import React, { useEffect, useState } from "react";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input'
import partnerServices from "../../../../../services/admFin/partnerServices";

import './styles.css'

export default function NewPartnerPopUp(props) {
    const [tipo, setTipo] = useState("");
    const [nome, setNome] = useState("");
    const [documento, setDocumento] = useState("");
    const [cep, setCep] = useState("");
    const [pais, setPais] = useState("");
    const [estado, setEstado] = useState("");
    const [cidade, setCidade] = useState("");
    const [bairro, setBairro] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [numero, setNumero] = useState("");
    const [inscricaoEstadual, setInscricaoEstadual] = useState("");
    const [iso2, setIso2] = useState('');
    const [dialCode, setDialCode] = useState('');
    const [telefone, setTelefone] = useState('');
    const [isValidNumber, setIsValidNumber] = useState('');

    useEffect(() => {
        if (props.partner && Object.keys(props.partner).length > 0) {
            setTipo(partnerServices.partnerType.find(subArr => subArr[0] === props.partner.tipo)[1]);
            setNome(props.partner.nome);
            setDocumento(props.partner.documento);
            setCep(props.partner.cep);
            setPais(props.partner.pais);
            setEstado(props.partner.estado);
            setCidade(props.partner.cidade);
            setBairro(props.partner.bairro);
            setLogradouro(props.partner.logradouro);
            setNumero(props.partner.numero);
            setInscricaoEstadual(props.partner.inscricao_estadual);
            setIso2(props.partner.iso2_ddi ? props.partner.iso2_ddi : "br");
            setDialCode(props.partner.ddi ? props.partner.ddi : "+55");
            setTelefone(props.partner.telefone);
        }
    }, [props.partner]);

    return (
        <Popup
            icon={props.icon}
            tittle={props.tittle}
            visibility={props.visibility}
            setVisibility={props.setVisibility}
        >
            <div className="line">
                <Input
                    label="Tipo*"
                    type="select"
                    id="new-partner-popup-type"
                    options={partnerServices.partnerType.map(subArr => subArr[1])}
                    onChange={(e) => setTipo(e.target.value)}
                    value={tipo}
                />

                <Input
                    label="Inscrição estadual"
                    placeholder="Digite a inscrição estadual"
                    id="new-partner-popup-state-registration"
                    onChange={(e) => setInscricaoEstadual(String(e.target.value).replace(/\D/g, ''))}
                    value={inscricaoEstadual}
                />
            </div>

            <Input
                label="Nome*"
                placeholder="Digite o nome"
                id="new-partner-popup-name"
                onChange={(e) => setNome(e.target.value)}
                value={nome}
            />

            <div className="line">
                <Input
                    label="Documento*"
                    placeholder="CPF ou CNPJ"
                    id="new-partner-popup-document"
                    onChange={(e) => setDocumento(String(e.target.value).replace(/\D/g, ''))}
                    value={documento}
                />

                <Input
                    label="CEP*"
                    placeholder="Digite o CEP"
                    id="new-partner-popup-cep"
                    onChange={(e) => setCep(String(e.target.value).replace(/\D/g, ''))}
                    value={cep}
                />
            </div>

            <div className="line">
                <Input
                    label="País*"
                    placeholder="Digite o país do parceiro"
                    id="new-partner-popup-country"
                    onChange={(e) => setPais(e.target.value)}
                    value={pais}
                />

                <Input
                    label="Estado*"
                    placeholder="Digite o estado do parceiro"
                    id="new-partner-popup-state"
                    onChange={(e) => setEstado(e.target.value)}
                    value={estado}
                />
            </div>

            <div className="line">
                <Input
                    label="Cidade*"
                    placeholder="Digite a cidade do parceiro"
                    id="new-partner-popup-city"
                    onChange={(e) => setCidade(e.target.value)}
                    value={cidade}
                />

                <Input
                    label="Bairro*"
                    placeholder="Digite o bairro do parceiro"
                    id="new-partner-popup-district"
                    onChange={(e) => setBairro(e.target.value)}
                    value={bairro}
                />
            </div>

            <Input
                label="Logradouro*"
                placeholder="Digite o logradouro do parceiro"
                id="new-partner-popup-public-place"
                onChange={(e) => setLogradouro(e.target.value)}
                value={logradouro}
            />

            <div className="line">
                <Input
                    label="Número residencial*"
                    type="number"
                    placeholder="Digite o número do parceiro"
                    id="new-partner-popup-number"
                    onChange={(e) => setNumero(e.target.value)}
                    value={numero}
                />

                <Input
                    label='Telefone'
                    type='tel'
                    placeholder="Telefone"
                    id='new-partner-popup-phone'
                    onChange={(event) => setTelefone(event.target.value)}
                    iso2={iso2}
                    setIso2={setIso2}
                    setDialCode={setDialCode}
                    setIsValidNumber={setIsValidNumber}
                    value={telefone}
                />
            </div>

            {/* <button onClick={() => props.onClick({ nome, logradouro, cidade, estado, cep, documento, tipo })}>{props.buttonTittle}</button> */}
            <button
                onClick={() => props.onClick({
                    tipo,
                    nome,
                    documento,
                    cep,
                    pais,
                    estado,
                    cidade,
                    bairro,
                    logradouro,
                    numero,
                    inscricaoEstadual,
                    iso2,
                    dialCode,
                    telefone
                })}
            >
                {props.buttonTittle}
            </button>

        </Popup>
    )
}